// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2qsLz","header":"PatientBlock_header__2_I4x","label":"PatientBlock_label__3nKxv","option":"PatientBlock_option__18YRV"};